"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgCornerRightDown = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M23 15a5 5 0 015 5v9.585l3.293-3.292a1 1 0 011.414 1.414l-5 5a1.006 1.006 0 01-.09.08l.09-.08a1.008 1.008 0 01-.674.292L27 33h-.032l-.054-.004L27 33a1.008 1.008 0 01-.617-.213 1.016 1.016 0 01-.09-.08l-5-5a1 1 0 011.414-1.414L26 29.585V20a3 3 0 00-3-3h-7a1 1 0 010-2h7z",
    id: "corner-right-down_svg__a"
  }));
};

var _default = SvgCornerRightDown;
exports.default = _default;